import { memo } from 'react';

import { getScopedTranslate } from '@locale/translate';

import { JourneyAction } from 'api/types';
import { getWaitRelativeDescriptionJourneyText } from 'ui/authenticated/main/helpers';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard, NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

type ActionType = 'wait_until_relative_date';

export const getDescription = (action: JourneyAction<ActionType>) => {
  return getWaitRelativeDescriptionJourneyText(action.values ?? {});
};

export const Node = memo((node: JourneyNode<ActionType>) => {
  const { t } = getScopedTranslate(nodeLocale);

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard node={node} label={t('title')}>
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    title: 'Wait until # date',
  },
};
